import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { FormDeleteService } from '../../services';
import { ToastResponse } from '../../utilities/ToastResponse';

export const fetchFormDelete = createAsyncThunk(
    'sliderGet/fetchFormDelete',
    async ({ id }) => {
        const response = await FormDeleteService(id)
        ToastResponse(response?.data?.statusCode, response?.data?.message)
        return response.result
    }
);

const formDeleteSlice = createSlice({
    name: 'formDelete',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFormDelete.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFormDelete.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchFormDelete.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default formDeleteSlice.reducer;
